import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Container, Modal,
  ModalBody,
  ModalHeader, Row
} from "reactstrap";

import { Form, Formik } from "formik";
import * as Yup from "yup";

import {
  DeleteModal,
  ErrorModal,
  RavenAgTable
} from "../../../components/Common/CombinedComponents";
import PageModalFooter from "../../../components/Common/PageComponents/PageModalFooter";
import RavenFormikField from "../../../components/Common/RavenFormikField";

import {
  getBooleanValue, getInitValue, getInitValueArray, getTitleValue
} from "../../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import {
  addUserRoleRelation, deleteUserRoleRelation, getRoleDefinitions, getUserDefinitions, getUserRoleRelation, updateUserRoleRelation, userRoleRelationError
} from "../../../store/actions";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class UserRoleRelation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      modal: false,
      record: "",
      deleteModal: false,
      memoModal: false,
      addAnother: false,
      isDetail: false,
      isEdit: false,
      userList: [],
      roleList: [],
      recordcolumns: [
        {
          headerName: this.props.t("userName"),
          field: "userDefinitionGuid",

          valueFormatter: params => this.getUserDefNameByGuid(params.value),
          filterParams: {
            valueFormatter: params => this.getUserDefNameByGuid(params.value),
          },
        },
        {
          headerName: this.props.t("roleName"),
          field: "userRoleDefinitionGuid",
          valueFormatter: params => this.getRoleDefNameByGuid(params.value),
          filterParams: {
            valueFormatter: params => this.getRoleDefNameByGuid(params.value),
          },
        },
        {
          headerName: this.props.t("status"),
          field: "status",
          valueFormatter: getBooleanValue,
          cellRenderer: "activePassiveCellRender",
          filterParams: { valueFormatter: getBooleanValue },
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
    this.handleAddRecordClick = this.handleAddRecordClick.bind(this);
    this.handleEditRecordClick = this.handleEditRecordClick.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
  }

  //#region Base Operations
  componentDidMount() {
    this.props.apiError("");
    const { recordList, onGetRecordList, onGetUserDefinition, onGetRoleDefinition, userList, roleList } =
      this.props;

    if (userList && !userList.length) {
      onGetUserDefinition();
    }
    this.setState({ userList });
    if (roleList && !roleList.length) {
      onGetRoleDefinition();
    }
    this.setState({ roleList });

    if (recordList && !recordList.length) {
      onGetRecordList();
    }
    this.setState({ recordList });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
  }

  //#endregion

  //#region Cruid Operations
  handleDetailClick = values => {
    this.setState({
      record: values,
      isDetail: true,
      isEdit: true,
    });

    this.toggle();
  };

  handleAddRecordClick = () => {
    this.setState({ record: "", isEdit: false });
    this.toggle();
  };

  handleEditRecordClick = args => {
    this.setState({
      record: args,
      isEdit: true,
    });

    this.toggle();
  };

  handleDeleteRecordClick = record => {
    const deleteGuid = record.userDefinitionGuid;
    const deleteRecord = {
      guid: record.userDefinitionGuid,
      userName: this.getUserDefNameByGuid(record.userDefinitionGuid),
    };
    this.setState({ record: deleteRecord, deleteGuid });
    this.setState({ deleteModal: true });
  };

  handleValidRecordSubmit = (values, actions) => {
    const { onAddRecord, onUpdateRecord } = this.props;
    const { isEdit, record } = this.state;
    if (isEdit) {
      values.guid = record.guid;
      onUpdateRecord(values);
    } else {
      
      onAddRecord(values);
    }
    !this.state.addAnother && this.toggle();
  };

  handleModalDeleteClick = e => {
    e.preventDefault();
    const { onDeleteRecord } = this.props;
    const { deleteGuid } = this.state;

    if (deleteGuid !== undefined) {
      onDeleteRecord(deleteGuid);
      this.setState({ deleteModal: false });
    }
  };
  //#endregion

  //#region Dom Elements Design
  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));

    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }
  //#endregion

  getUserDefNameByGuid(guid) {
    let array = this.props.userList.filter(i => i.guid === guid).map(x => x);

    if (array?.length) return array[0].userName;
    else return guid;
  }

  getRoleDefNameByGuid(guidList) {
    let returnArray = new Array();
    for (const item of guidList) {

      let array = this.props.roleList.filter(i => i.guid === item).map(x => x)[0]?.name;
      if (array !== undefined) {
        returnArray.push(array);
      }
    }

    if (returnArray?.length) return returnArray.sort((a, b) => a.name.localeCompare(b.name));
    else return guidList;
  }

  render() {
    const { recordList,loading } = this.props;
    const { record, error, deleteModal } = this.state;

    this.props.userList.sort((a, b) =>
      a.userName.localeCompare(b.userName),
    );
    this.props.roleList.sort((a, b) =>
      a.name.localeCompare(b.name),
    );

    return (
      <React.Fragment>

        <DeleteModal
          record={record}
          show={deleteModal}
          onDeleteClick={this.handleModalDeleteClick}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined })} />)}
        <ToastContainer />
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <RavenAgTable
                      onAddClick={this.handleAddRecordClick}
                      onEditClick={this.handleEditRecordClick}
                      onDetailClick={this.handleDetailClick}
                      onDeleteClick={this.handleDeleteRecordClick}
                      actionItems={true}
                      breadCrumbTitle={this.props.t("userManagement")}
                      breadCrumbItem={this.props.t("userRoleRelation")}
                      exportOption={false}
                      recordcolumns={this.state.recordcolumns}
                      recordList={recordList}
                      loading={loading}
                    />
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                      onClose={this.toggleModalClose}
                      size="xs"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {getTitleValue(this, "userRoleRelation")}
                      </ModalHeader>
                      <ModalBody>
                        <Formik
                          key="formik1"
                          initialValues={{
                            userDefinitionGuid: getInitValue(record, record.userDefinitionGuid),
                            userRoleDefinitionGuid: getInitValueArray(record, record.userRoleDefinitionGuid),
                          }}
                          enableReinitialize={true}
                          validationSchema={Yup.object().shape({

                            userDefinitionGuid: Yup.string()
                            .required(
                              this.props.t("mustBe")),
                              
                            userRoleDefinitionGuid: Yup.array().required(
                              this.props.t("mustBe")),

                          })}
                          onSubmit={(values, actions) => {
                            this.handleValidRecordSubmit(values, actions);
                          }}
                        >
                          {({
                            errors,
                            status,
                            touched,
                            setFieldValue,
                            values,
                          }) => (
                            <Form>
                              <fieldset disabled={this.state.isDetail}>
                                <Row>
                                  <Col lg={12} className="col-12">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"userDefinitionGuid"}
                                      label={"userName"}
                                      component="multiselect"
                                      type="singleselect"
                                      valueList={this.props.userList}
                                      nameOnValueList={[
                                        "userName"
                                      ]}
                                      disabled={this.state.isDetail || this.state.isEdit}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={12} className="col-12">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"userRoleDefinitionGuid"}
                                      label={"roleName"}
                                      component="multiselect"
                                      valueList={
                                        this.props.roleList.sort((a, b) =>
                                          a.name.localeCompare(b.name),
                                        )
                                      }
                                      type="multiselect"
                                      nameOnValueList={"name"}
                                      disabled={this.state.isDetail}
                                    />
                                  </Col>
                                </Row>
                              </fieldset>
                              <ModalHeader
                                style={{
                                  marginTop: "-30px",
                                  marginBottom: "10px",
                                }}
                              ></ModalHeader>
                              <PageModalFooter
                                isEdit={this.state.isEdit}
                                isDetail={this.state.isDetail}
                                onCheckboxClick={() => {
                                  this.setState({
                                    addAnother: !this.state.addAnother,
                                  });
                                }}
                                onCancelClick={() => this.toggle()}
                              />
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

UserRoleRelation.propTypes = {
  recordList: PropTypes.array,
  userList: PropTypes.array,
  roleList: PropTypes.array,
  loading: PropTypes.bool,
  onGetRecordList: PropTypes.func,
  onAddRecord: PropTypes.func,
  onUpdateRecord: PropTypes.func,
  onDeleteRecord: PropTypes.func,
  onGetUserDefinition: PropTypes.func,
  onGetRoleDefinition: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
};

const mapStateToProps = ({ userRoleRelation, UserDefinition, roleDefinition }) => ({
  recordList: userRoleRelation.recordList,
  loading: userRoleRelation.loading,
  userList: UserDefinition.userDefinitions,
  roleList: roleDefinition.roleDefinitions,
  error: userRoleRelation.error,
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList: () => dispatch(getUserRoleRelation()),
  onAddRecord: record => dispatch(addUserRoleRelation(record)),
  onUpdateRecord: record => dispatch(updateUserRoleRelation(record)),
  onDeleteRecord: guid => dispatch(deleteUserRoleRelation(guid)),
  onGetUserDefinition: () => dispatch(getUserDefinitions()),
  onGetRoleDefinition: () => dispatch(getRoleDefinitions()),
  apiError: error => dispatch(userRoleRelationError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(UserRoleRelation));
